// 생년월일 6자리 형식
export const regExp_birth = /^([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1,2][0-9]|3[0,1]))/;
// 휴대폰번호 13자리 형식
export const regExp_phone = /^(01[016789]{1}|0[3-9]{1}[0-9]{1})-([0-9]{3,4})-([0-9]{4})$/;
// 비밀번호 영문,숫자,특수문자 포함 8자리 이상
export const regExp_pwd = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/g;
